import { assignTrainings } from 'api/training';
import { debounceDriver } from 'utils/debounces';

import type { FormType } from '..';

export const driverTrainingForm: FormType = {
  createFn: assignTrainings,
  submitText: 'Atribuir Treinamento',
  cancelText: 'Cancelar',
  successText: 'Treinamento atribuido com sucesso!',
  fields: [
    [{
      name: 'drivers',
      type: 'select',
      required: true,
      isMultiple: true,
      props: {
        placeholder: 'Buscar',
        label: 'Condutor',
        loadOptions: debounceDriver,
      },
    }],
  ],
};
